export const common = {
  // Navigation
  'nav.home': 'Anasayfa',
  'nav.corporate': 'Kurumsal',
  'nav.collections': 'Koleksiyonlar',
  'nav.documents': 'Belgelerimiz',
  'nav.sales': 'Satış',
  'nav.contact': 'İletişim',
  'nav.hr': 'İnsan Kaynakları',
  'nav.dealerLogin': 'Bayi Girişi',
  'nav.dealerApplication': 'Bayilik Başvurusu',
  'nav.search': 'Halı ara...',
  'nav.dayMode': 'Gündüz',
  'nav.nightMode': 'Gece',

  // Quick Menu
  'quickMenu.title': 'Hızlı Menü',
  'quickMenu.subtitle': 'MONS HALI Halı',
  'quickMenu.language': 'Dil',
  'quickMenu.collections': 'Koleksiyonlar',
  'quickMenu.dealerLogin': 'Bayi Girişi',
  'quickMenu.dealerLoginDesc': 'Bayi paneline erişin',
  'quickMenu.contact': 'İletişim',
  'quickMenu.kvkk': 'KVKK & Belgeler',
  'quickMenu.whatsapp': 'WhatsApp',
  'quickMenu.whatsappDesc': 'Mesaj gönder',
  'quickMenu.call': 'Ara',
  'quickMenu.callDesc': 'Hemen ara',

  // TopBanner
  'topBanner.quality': '✓ Kalite Güvencesi',
  'topBanner.production': '✓ Dünya Standartlarında Üretim',
  'topBanner.design': '✓ Modern Tasarımlar',
  'topBanner.experience': '✓ 30 Yıllık Tecrübe',
  'topBanner.certified': '✓ ISO 9001 Sertifikalı',

  // Collections Grid
  'collectionsGrid.specialCategories': '10 Özel Kategori',
  'collectionsGrid.title': 'Koleksiyonlarımız',
  'collectionsGrid.subtitle': 'Farklı tarz ve ihtiyaçlara uygun premium halı koleksiyonlarımızı keşfedin.',
  'collectionsGrid.viewAll': 'Tümünü Görüntüle',
  'collectionsGrid.wholesaleCarpet': 'Toptan Halı',
  'collectionsGrid.wholesaleBadge': 'Toptan Halı',
  'collectionsGrid.products': 'ürün',
  'collectionsGrid.page': 'Sayfa',
  'collectionsGrid.notFound': 'Ürün Bulunamadı',
  'collectionsGrid.notFoundDesc': 'Bu kategoride henüz ürün bulunmamaktadır.',
  'collectionsGrid.showAll': 'Tüm Ürünleri Göster',
  'collectionsGrid.exploreAll': 'Tüm Koleksiyonları Keşfet',
  'collectionsGrid.category.all': 'Tümü',
  'collectionsGrid.category.modern': 'Toptan Halı',
  'collectionsGrid.category.classic': 'Toptan Halı',
  'collectionsGrid.category.minimalist': 'Toptan Halı',
  'collectionsGrid.category.bohemian': 'Toptan Halı',
  'collectionsGrid.category.geometric': 'Toptan Halı',
  'collectionsGrid.category.natural': 'Toptan Halı',
  'collectionsGrid.category.luxury': 'Toptan Halı',
  'collectionsGrid.category.vintage': 'Toptan Halı',
  'collectionsGrid.category.ethnic': 'Toptan Halı',
  'collectionsGrid.category.kids': 'Toptan Halı',

  // Certificates
  'certificates.title': 'Sertifikalarımız',
  'certificates.subtitle': 'Kalite ve güven belgeleri',

  // FactoryGallery
  'factoryGallery.title': 'Üretim Tesisimiz',
  'factoryGallery.subtitle': 'Modern teknoloji ve usta ellerin buluştuğu fabrikamızdan anlar',

  // CustomerGallery
  'customerGallery.title': 'İlham Veren Mekanlar',
  'customerGallery.subtitle': 'Halı Kombinlerimiz',
  'customerGallery.description': 'Farklı mekanlarda halılarımızın yarattığı benzersiz atmosferi keşfedin',
  'customerGallery.newCollection': 'Yeni Koleksiyon',
  'customerGallery.catalogButton': '2026 KATALOG',
  'customerGallery.catalogDesc': 'Yeni koleksiyonumuzu keşfedin • 10 sayfa',

  // SocialResponsibility
  'socialResponsibility.title': 'Sosyal Sorumluluk',
  'socialResponsibility.subtitle': 'Sürdürülebilir gelecek için attığımız adımlar',
  'socialResponsibility.goToCollections': 'Koleksiyonlara Git',
  'socialResponsibility.slide1Title': 'Yeşil Gelecek İçin Üretim',
  'socialResponsibility.slide1Desc': 'Doğaya saygılı üretim süreçlerimizle karbon ayak izimizi minimize ediyor, sürdürülebilir hammaddeler kullanarak çevre dostu halılar üretiyoruz.',
  'socialResponsibility.slide2Title': 'Topluma Değer Katıyoruz',
  'socialResponsibility.slide2Desc': 'Eğitimden sağlığa, kültürden sanata kadar geniş bir yelpazede sosyal sorumluluk projeleri yürütüyor, toplumun her kesimine dokunuyoruz.',
  'socialResponsibility.slide3Title': 'Sürdürülebilir Hammadde',
  'socialResponsibility.slide3Desc': 'Geri dönüştürülmüş iplikler ve organik lifler kullanarak üretim yapıyor, doğal kaynakların korunmasına öncülük ediyoruz.',

  // BlogSection
  'blogSection.title': 'Blog & Haberler',
  'blogSection.subtitle': 'Tekstil dünyasından güncel haberler ve ilham verici içerikler',
  'blogSection.readMore': 'Devamını Oku',
  'blogSection.allPosts': 'Tüm Blog Yazıları',

  // GlobalImpact
  'globalImpact.title': 'Dünya Genelinde Hizmet',
  'globalImpact.subtitle': 'Global Kurumsal Etki',
  'globalImpact.exportCountries': 'İhracat Ülkeleri',
  'globalImpact.annualShipments': 'Yıllık Sevkiyat',
  'globalImpact.continents': 'Kıtaya Ulaşım',
  'globalImpact.carpetExport': 'm² Halı İhracatı',
  'globalImpact.description': 'Gaziantep\'ten dünyaya uzanan kalite yolculuğumuzda, 50\'den fazla ülkeye ihracat yaparak global pazarda güçlü bir konuma sahibiz. Her kıtada müşterilerimize ulaşıyor, dünya standartlarında ürünlerimizle evlere değer katıyoruz.',
  'globalImpact.country.turkey': 'Türkiye',
  'globalImpact.country.germany': 'Almanya',
  'globalImpact.country.france': 'Fransa',
  'globalImpact.country.uk': 'İngiltere',
  'globalImpact.country.italy': 'İtalya',
  'globalImpact.country.spain': 'İspanya',
  'globalImpact.country.netherlands': 'Hollanda',
  'globalImpact.country.belgium': 'Belçika',
  'globalImpact.country.poland': 'Polonya',
  'globalImpact.country.romania': 'Romanya',
  'globalImpact.country.uae': 'BAE',
  'globalImpact.country.saudiArabia': 'Suudi Arabistan',
  'globalImpact.country.qatar': 'Katar',
  'globalImpact.country.kuwait': 'Kuveyt',
  'globalImpact.country.oman': 'Umman',
  'globalImpact.country.jordan': 'Ürdün',
  'globalImpact.country.lebanon': 'Lübnan',
  'globalImpact.country.iraq': 'Irak',
  'globalImpact.country.egypt': 'Mısır',
  'globalImpact.country.morocco': 'Fas',
  'globalImpact.country.china': 'Çin',
  'globalImpact.country.japan': 'Japonya',
  'globalImpact.country.southKorea': 'Güney Kore',
  'globalImpact.country.singapore': 'Singapur',
  'globalImpact.country.malaysia': 'Malezya',
  'globalImpact.country.thailand': 'Tayland',
  'globalImpact.country.india': 'Hindistan',
  'globalImpact.country.pakistan': 'Pakistan',
  'globalImpact.country.southAfrica': 'Güney Afrika',
  'globalImpact.country.nigeria': 'Nijerya',
  'globalImpact.country.kenya': 'Kenya',
  'globalImpact.country.usa': 'ABD',
  'globalImpact.country.canada': 'Kanada',
  'globalImpact.country.brazil': 'Brezilya',
  'globalImpact.country.argentina': 'Arjantin',
  'globalImpact.country.australia': 'Avustralya',
  'globalImpact.country.newZealand': 'Yeni Zelanda',

  // HeroSlider
  'heroSlider.exploreCollections': 'Koleksiyonları İncele',
  'heroSlider.discoverCollection': 'Koleksiyonu Keşfet',

  // DealerBanner
  'dealerBanner.title': 'Bayi Ağımıza Katılın',
  'dealerBanner.subtitle': 'Türkiye\'nin En Prestijli',
  'dealerBanner.subtitle2': 'Halı Bayi Ağı',
  'dealerBanner.description': 'Premium koleksiyonlarımızla işinizi büyütün. Özel bayi fiyatları, pazarlama desteği ve ayrıcalıklı hizmetlerden yararlanın.',
  'dealerBanner.cardSubtitle': 'Giriş yapın veya hemen kayıt olun',
  'dealerBanner.activeDealers': 'Aktif Bayi',
  'dealerBanner.cityReach': 'İl Kapsamı',
  'dealerBanner.profitMargin': 'Kâr Marjı',
  'dealerBanner.dealerPortal': 'Bayi Portalı',
  'dealerBanner.dealerLogin': 'Bayi Girişi',
  'dealerBanner.createAccount': 'Bayi Kaydı Oluştur',
  'dealerBanner.secureLogin': 'Güvenli Giriş',
  'dealerBanner.support247': '7/24 Destek',

  // DealerFloat
  'dealerFloat.intro': 'TANITIM',
  'dealerFloat.dealerLogin': 'BAYİ GİRİŞİ',
  'dealerFloat.likes': 'BEĞENİ',
  'dealerFloat.dealerPortal': 'Bayi Portalı',
  'dealerFloat.username': 'Kullanıcı Adı',
  'dealerFloat.password': 'Şifre',
  'dealerFloat.rememberMe': 'Beni Hatırla',
  'dealerFloat.forgotPassword': 'Şifremi Unuttum',
  'dealerFloat.login': 'Giriş Yap',
  'dealerFloat.noAccount': 'Hesabınız yok mu?',
  'dealerFloat.registerNow': 'Hemen Kayıt Olun',
  'dealerFloat.companyName': 'Firma Adı',
  'dealerFloat.authorizedName': 'Yetkili Adı',
  'dealerFloat.email': 'E-posta',
  'dealerFloat.phone': 'Telefon',
  'dealerFloat.city': 'Şehir',
  'dealerFloat.address': 'Adres',
  'dealerFloat.taxNumber': 'Vergi No',
  'dealerFloat.register': 'Kayıt Ol',
  'dealerFloat.haveAccount': 'Zaten hesabınız var mı?',
  'dealerFloat.loginNow': 'Giriş Yapın',
  'dealerFloat.introTitle': 'MONS HALI\'ya Hoş Geldiniz',
  'dealerFloat.introDesc': 'Halı üretiminde kalite ve zarafeti keşfedin. Koleksiyonlarımızı inceleyin ve hayalinizdeki halıyı bulun.',
  'dealerFloat.exploreCollections': 'Koleksiyonları Keşfet',
  'dealerFloat.becomeDealer': 'Bayi Olun',

  // ContactFloat
  'contactFloat.whatsapp': 'WhatsApp',
  'contactFloat.phone': 'Telefon',
  'contactFloat.email': 'E-posta',
  'contactFloat.location': 'Konum',
  'contactFloat.message': 'Mesaj',
  'contactFloat.dealerLogin': 'Bayi Girişi',
  'contactFloat.sendMessage': 'Mesaj Gönder',
  'contactFloat.yourName': 'Adınız',
  'contactFloat.yourEmail': 'E-posta Adresiniz',
  'contactFloat.yourPhone': 'Telefon Numaranız',
  'contactFloat.yourMessage': 'Mesajınız',
  'contactFloat.send': 'Gönder',

  // Corporate Submenu
  'corporate.history': 'Tarihçe',
  'corporate.visionMission': 'Vizyon & Misyon',
  'corporate.regions': 'Bölgelerimiz',
  'corporate.certificates': 'Sertifikalarımız',
  'corporate.eCatalog': 'E-Katalog',
  'corporate.productionProcess': 'Üretim Süreci',
  'corporate.wholesaleCarpet': 'Toptan Halı Üretimi',
  'corporate.blogNews': 'Blog & Haberler',
  'corporate.gaziantepCarpet': 'Gaziantep Carpet',

  // Collections Categories
  'collections.categories': 'Kategoriler',
  'collections.bella': 'Bella',
  'collections.sensitive': 'Sensitive',
  'collections.craft': 'Craft',
  'collections.pretty': 'Pretty',
  'collections.balmoral': 'Balmoral',
  'collections.barbados': 'Barbados',
  'collections.calverts': 'Calverts',
  'collections.hamptons': 'Hamptons',
  'collections.heavenlyTwist': 'Heavenly Twist',
  'collections.pashmina': 'Pashmina',
  'collections.saratoga': 'Saratoga',
  'collections.selina': 'Selina',
  'collections.serenade': 'Serenade',
  'collections.softJasmine': 'Soft Jasmine',
  'collections.softSupreme': 'Soft Supreme',
  'collections.sweetDreams': 'Sweet Dreams',
  'collections.olympus': 'Olympus',

  // Footer
  'footer.quickLinks': 'Hızlı Linkler',
  'footer.corporate': 'Kurumsal',
  'footer.collections': 'Koleksiyonlar',
  'footer.contact': 'İletişim',
  'footer.followUs': 'Bizi Takip Edin',
  'footer.newsletter': 'Bülten',
  'footer.newsletterDesc': 'Yeni ürünler ve kampanyalardan haberdar olmak için bültenimize abone olun.',
  'footer.emailPlaceholder': 'E-posta adresiniz',
  'footer.subscribe': 'Abone Ol',
  'footer.allRightsReserved': 'Tüm hakları saklıdır.',
  'footer.companyName': '2026 Toptan Halı Fabrikası.',
  'footer.poweredBy': 'yazılımı tarafından desteklenmektedir',
  'footer.seoLinks.title': 'Popüler Halı Kategorileri',
  'footer.seoLinks.wholesaleCarpet': 'Toptan Halı Satışı',
  'footer.seoLinks.modernCarpet': 'Modern Halı',
  'footer.seoLinks.luxuryCarpet': 'Lüks Halı',
  'footer.seoLinks.carpetExport': 'Halı İhracatı',
  'footer.seoLinks.carpetProduction': 'Halı Üretimi',
  'footer.seoLinks.handwovenCarpet': 'El Dokuma Halı',
  'footer.seoLinks.carpetDealer': 'Halı Bayiliği',
  'footer.seoLinks.turkishCarpet': 'Türk Halısı',
  'footer.seoLinks.carpetFair': 'Halı Fuarları',
  'footer.seoLinks.qualityCarpet': 'Kaliteli Halı',
  'footer.seoLinks.hotelCarpet': 'Otel Halısı',
  'footer.seoLinks.vintageCarpet': 'Vintage Halı',
  'footer.seoLinks.carpetWholesale': 'Halı Toptan',
  'footer.seoLinks.ecoCarpet': 'Çevre Dostu Halı',
  'footer.seoLinks.carpetFactory': 'Halı Fabrikası',

  // Welcome Popup
  'popup.welcome': 'MONS HALI\'ya Hoş Geldiniz',
  'popup.description': 'Halı üretiminde kalite ve zarafeti keşfedin. Koleksiyonlarımızı inceleyin ve hayalinizdeki halıyı bulun.',
  'popup.explore': 'Koleksiyonları Keşfet',
  'popup.close': 'Kapat',

  // Home Page
  'home.hero.title': 'Halı Üretiminde Kalite ve Zarafet',
  'home.hero.subtitle': 'Modern tasarımlar ve üstün kalite ile yaşam alanlarınıza değer katan koleksiyonlarımızı keşfedin.',
  'home.hero.cta': 'Koleksiyonları Keşfet',
  'home.hero.contact': 'İletişime Geçin',

  'home.welcome.title': 'MONS HALI\'ya Hoş Geldiniz',
  'home.welcome.description': 'MONS HALI olarak yıllardır kaliteli halı üretimi yapıyoruz. Modern üretim tesislerimiz ve uzman ekibimizle müşterilerimize en iyi ürünleri sunuyoruz.',
  'home.welcome.learnMore': 'Daha Fazla Bilgi',

  'home.collections.title': 'Koleksiyonlarımız',
  'home.collections.subtitle': 'Özel koleksiyonlarımızı keşfedin',
  'home.collections.viewAll': 'Tümünü Gör',

  'home.certificates.title': 'Sertifikalarımız',
  'home.certificates.subtitle': 'Kalite ve güven belgeleri',

  'home.factory.title': 'Fabrikamız',
  'home.factory.subtitle': 'Modern üretim tesisleri',

  'home.customers.title': 'Müşterilerimiz',
  'home.customers.subtitle': 'Bize güvenen markalar',

  'home.social.title': 'Sosyal Sorumluluk',
  'home.social.subtitle': 'Toplum için projelerimiz',

  'home.blog.title': 'Blog',
  'home.blog.subtitle': 'Son haberler ve yazılar',
  'home.blog.readMore': 'Devamını Oku',

  // Dealer Login Page
  'dealer.login.title': 'Bayi Girişi',
  'dealer.login.subtitle': 'Bayi paneline erişmek için giriş yapın',
  'dealer.login.email': 'E-posta Adresi',
  'dealer.login.password': 'Şifre',
  'dealer.login.remember': 'Beni Hatırla',
  'dealer.login.forgot': 'Şifremi Unuttum?',
  'dealer.login.button': 'Giriş Yap',
  'dealer.login.noAccount': 'Hesabınız yok mu?',
  'dealer.login.apply': 'Bayilik Başvurusu Yap',

  // Dealer Application Page
  'dealer.application.title': 'Bayilik Başvurusu',
  'dealer.application.subtitle': 'Bayi olmak için formu doldurun',
  'dealer.application.companyName': 'Firma Adı',
  'dealer.application.contactPerson': 'Yetkili Kişi',
  'dealer.application.email': 'E-posta Adresi',
  'dealer.application.phone': 'Telefon',
  'dealer.application.address': 'Adres',
  'dealer.application.city': 'Şehir',
  'dealer.application.country': 'Ülke',
  'dealer.application.experience': 'Deneyim Yılı',
  'dealer.application.message': 'Mesaj',
  'dealer.application.submit': 'Başvuruyu Gönder',
  'dealer.application.success': 'Başvurunuz alınmıştır. En kısa sürede sizinle iletişime geçeceğiz.',

  // Documents Page
  'documents.title': 'Belgelerimiz',
  'documents.subtitle': 'Kalite sertifikalarımız ve belgelerimiz',
  'documents.download': 'İndir',
  'documents.view': 'Görüntüle',

  // Collections Page
  'collections.title': 'Koleksiyonlarımız',
  'collections.subtitle': 'Özel halı koleksiyonlarımızı keşfedin',
  'collections.all': 'Tümü',
  'collections.filter': 'Kategoriye Göre Filtrele',
  'collections.viewDetails': 'Detayları Gör',
  'collections.addToCart': 'Sepete Ekle',

  // Sales Page
  'sales.title': 'Satış',
  'sales.subtitle': 'Ürünlerimizi keşfedin',
  'sales.featured': 'Öne Çıkan Ürünler',
  'sales.newArrivals': 'Yeni Gelenler',
  'sales.bestSellers': 'Çok Satanlar',
  'sales.viewProduct': 'Ürünü Görüntüle',
  'sales.networkTitle': 'Satış Ağımız',
  'sales.networkSubtitle': 'Türkiye genelinde 170\'den fazla bayi ve 4 showroom ile hizmetinizdeyiz',
  'sales.totalDealers': 'Toplam Bayi',
  'sales.cities': 'İl',
  'sales.showrooms': 'Showroom',
  'sales.countries': 'İhracat Ülkesi',
  'sales.regionalNetwork': 'Bölgesel Satış Ağı',
  'sales.regionalNetworkDesc': 'Türkiye\'nin 7 bölgesinde güçlü bayi ağımızla yanınızdayız',
  'sales.allRegions': 'Tüm Bölgeler',
  'sales.dealer': 'Bayi',
  'sales.activeCities': 'Aktif Şehirler',
  'sales.showroomsTitle': 'Showroom\'larımız',
  'sales.showroomsDesc': 'Ürünlerimizi yerinde görmek ve deneyimlemek için showroom\'larımızı ziyaret edin',
  'sales.getDirections': 'Yol Tarifi Al',
  'sales.becomeDealer': 'Bayimiz Olun',
  'sales.becomeDealerDesc': 'Türkiye\'nin önde gelen halı markasının güçlü bayi ağına katılın. Özel avantajlar ve desteklerle işinizi büyütün.',
  'sales.applyNow': 'Hemen Başvur',
  'sales.callUs': 'Bizi Arayın',
  'sales.globalReach': 'Global Erişim',
  'sales.globalReachDesc': '50\'den fazla ülkede güçlü bir marka olarak, kalite carpet üretiminin temsilcisiyiz. Avrupa, Orta Doğu, Asya ve Afrika\'da güvenilir iş ortaklarımızla çalışıyoruz.',
  'sales.europe': 'Avrupa',
  'sales.middleEast': 'Orta Doğu',
  'sales.asia': 'Asya',
  'sales.africa': 'Afrika',
  'sales.exportInquiry': 'İhracat Talebi',

  // Contact Page
  'contact.title': 'İletişim',
  'contact.subtitle': 'Bizimle iletişime geçin',
  'contact.heroSubtitle': 'Bizimle iletişime geçin, size yardımcı olmaktan mutluluk duyarız',
  'contact.info': 'İletişim Bilgileri',
  'contact.address': 'Adres',
  'contact.addressValue': 'Organize Sanayi Bölgesi, 5. Cadde No: 42, Gaziantep, Türkiye',
  'contact.phone': 'Telefon',
  'contact.email': 'E-posta',
  'contact.workingHours': 'Çalışma Saatleri',
  'contact.workingHoursValue': 'Pazartesi - Cuma: 08:00 - 18:00',
  'contact.visitUs': 'Bizi Ziyaret Edin',
  'contact.visitUsDesc': 'Fabrikamızı ve showroom\'umuzu ziyaret etmek için randevu alabilirsiniz.',
  'contact.mapTitle': 'Konum Haritası',
  'contact.form.title': 'Bize Mesaj Gönderin',
  'contact.form.reachUs': 'Bize Ulaşın',
  'contact.form.reachUsDesc': 'Sorularınız, önerileriniz veya iş birliği teklifleriniz için formu doldurun, en kısa sürede size dönüş yapalım.',
  'contact.form.name': 'Ad Soyad',
  'contact.form.namePlaceholder': 'Adınız ve soyadınız',
  'contact.form.email': 'E-posta',
  'contact.form.emailPlaceholder': 'ornek@email.com',
  'contact.form.phone': 'Telefon',
  'contact.form.phonePlaceholder': '+90 5XX XXX XX XX',
  'contact.form.subject': 'Konu',
  'contact.form.subjectPlaceholder': 'Konu seçiniz',
  'contact.form.subject.general': 'Genel Bilgi',
  'contact.form.subject.product': 'Ürün Bilgisi',
  'contact.form.subject.dealer': 'Bayilik',
  'contact.form.subject.sales': 'Satış',
  'contact.form.subject.support': 'Teknik Destek',
  'contact.form.message': 'Mesajınız',
  'contact.form.messagePlaceholder': 'Mesajınızı buraya yazın... (Maksimum 500 karakter)',
  'contact.form.send': 'Gönder',
  'contact.form.success': 'Mesajınız başarıyla gönderildi.',

  // HR Page
  'hr.title': 'İnsan Kaynakları',
  'hr.subtitle': 'Ekibimize katılın',
  'hr.openPositions': 'Açık Pozisyonlar',
  'hr.apply': 'Başvur',
  'hr.noPositions': 'Şu anda açık pozisyon bulunmamaktadır.',
  'hr.form.title': 'İş Başvuru Formu',
  'hr.form.fullName': 'Ad Soyad',
  'hr.form.email': 'E-posta Adresi',
  'hr.form.phone': 'Telefon',
  'hr.form.position': 'Başvurulan Pozisyon',
  'hr.form.cv': 'CV Yükle',
  'hr.form.coverLetter': 'Ön Yazısı',
  'hr.form.submit': 'Başvuruyu Gönder',
  'hr.form.success': 'Başvurunuz alınmıştır.',

  // Corporate - History
  'history.title': 'Tarihçemiz',
  'history.subtitle': 'Geçmişten günümüze yolculuğumuz',

  // Corporate - Vision & Mission
  'vision.title': 'Vizyon & Misyon',
  'vision.subtitle': 'Hedeflerimiz ve değerlerimiz',
  'vision.ourVision': 'Vizyonumuz',
  'vision.ourMission': 'Misyonumuz',
  'vision.ourValues': 'Değerlerimiz',

  // Vision Mission Page
  'visionMission.heroTitle': 'Vizyon & Misyon',
  'visionMission.heroSubtitle': 'Geleceğe dair hedeflerimiz ve değerlerimiz',
  'visionMission.heroAlt': 'Vizyon Misyon',
  'visionMission.ourVision': 'Vizyonumuz',
  'visionMission.visionImgAlt': 'Vizyon',
  'visionMission.visionP1': 'Dünya halı sektöründe kalite, inovasyon ve sürdürülebilirlik alanlarında öncü marka olmak. Türk halı sanatını modern üretim teknikleriyle birleştirerek global pazarda en çok tercih edilen lüks halı üreticisi konumuna ulaşmak.',
  'visionMission.visionP2': '2030 yılına kadar 100\'den fazla ülkede varlık göstererek, yıllık 2 milyon m² üretim kapasitesine ulaşmayı ve sektörde sürdürülebilir üretimin öncüsü olmayı hedefliyoruz.',
  'visionMission.ourMission': 'Misyonumuz',
  'visionMission.missionImgAlt': 'Misyon',
  'visionMission.missionP1': 'En son teknoloji ve geleneksel el sanatlarını birleştirerek, dünya standartlarında lüks halılar üretmek. Müşterilerimize estetik, konfor ve dayanıklılığı bir arada sunan ürünler sunarak yaşam alanlarına değer katmak.',
  'visionMission.missionP2': 'Çevre dostu üretim süreçleri, etik iş uygulamaları ve sürekli gelişim odaklı çalışma prensiplerimizle sektöre örnek olmak ve tüm paydaşlarımıza değer yaratmak.',
  'visionMission.ourValues': 'Değerlerimiz',
  'visionMission.valuesSubtitle': 'Çalışma prensiplerimizi şekillendiren ve bizi başarıya taşıyan temel değerlerimiz',
  'visionMission.value1.title': 'Kalite',
  'visionMission.value1.desc': 'Her üretim aşamasında en yüksek kalite standartlarını koruyarak müşterilerimize mükemmel ürünler sunuyoruz.',
  'visionMission.value2.title': 'Sürdürülebilirlik',
  'visionMission.value2.desc': 'Çevre dostu üretim süreçleri ve yenilenebilir enerji kullanımıyla geleceğe sorumlu yatırım yapıyoruz.',
  'visionMission.value3.title': 'İnovasyon',
  'visionMission.value3.desc': 'Ar-Ge çalışmalarımızla sektöre yön veren yenilikçi ürünler ve üretim teknikleri geliştiriyoruz.',
  'visionMission.value4.title': 'İnsan Odaklılık',
  'visionMission.value4.desc': 'Çalışanlarımızın gelişimine yatırım yaparak mutlu ve üretken bir iş ortamı oluşturuyoruz.',
  'visionMission.value5.title': 'Müşteri Memnuniyeti',
  'visionMission.value5.desc': 'Müşterilerimizin beklentilerini aşan hizmet anlayışıyla uzun vadeli iş ortaklıkları kuruyoruz.',
  'visionMission.value6.title': 'Küresel Bakış',
  'visionMission.value6.desc': 'Dünya pazarlarında Türk halı sektörünü en iyi şekilde temsil ederek ülkemizi gururlandırıyoruz.',

  // Corporate - Regions
  'regions.title': 'Bölgelerimiz',
  'regions.subtitle': 'Hizmet verdiğimiz bölgeler',

  // Corporate - E-Catalog
  'catalog.title': 'E-Katalog',
  'catalog.subtitle': 'Dijital kataloğumuza göz atın',
  'catalog.download': 'Katalogu İndir',
  'catalog.view': 'Online Görüntüle',

  // Common
  'common.loading': 'Yükleniyor...',
  'common.error': 'Bir hata oluştu',
  'common.success': 'Başarılı',
  'common.cancel': 'İptal',
  'common.save': 'Kaydet',
  'common.delete': 'Sil',
  'common.edit': 'Düzenle',
  'common.close': 'Kapat',
  'common.back': 'Geri',
  'common.next': 'İleri',
  'common.previous': 'Önceki',
  'common.search': 'Ara',
  'common.filter': 'Filtrele',
  'common.sort': 'Sırala',
  'common.viewAll': 'Tümünü Gör',
  'common.learnMore': 'Daha Fazla Bilgi',
  'common.readMore': 'Devamını Oku',
  'common.showMore': 'Daha Fazla Göster',
  'common.showLess': 'Daha Az Göster',

  // Blog Page
  'blog.heroLabel': 'Blog & Haberler',
  'blog.heroTitle': 'Halı Dünyasından Haberler',
  'blog.heroSubtitle': 'Sektör haberleri, koleksiyon tanıtımları, fuar raporları ve daha fazlası',
  'blog.breadcrumbHome': 'Anasayfa',
  'blog.breadcrumbBlog': 'Blog',
  'blog.categoryAll': 'Tümü',
  'blog.categoryFair': 'Fuar',
  'blog.categoryExport': 'İhracat',
  'blog.categoryCollection': 'Koleksiyon',
  'blog.categorySustainability': 'Sürdürülebilirlik',
  'blog.categoryCampaign': 'Kampanya',
  'blog.categoryProduction': 'Üretim',
  'blog.categoryProject': 'Proje',
  'blog.categoryGuide': 'Rehber',
  'blog.seoIntro': 'Halı sektörünün en güncel haberleri, koleksiyon tanıtımları, fuar raporları ve ihracat bilgileri için doğru adrestesiniz. <strong>Toptan halı satışı</strong>, üretim süreçleri ve sürdürülebilirlik konularında uzman içeriklerimizi keşfedin.',
  'blog.noPostsInCategory': 'Bu kategoride henüz yazı bulunmamaktadır.',
  'blog.readMore': 'Devamını Oku',
  'blog.readTime': 'dk okuma',
  'blog.share': 'Paylaş',
  'blog.seoCard1Title': 'Toptan Halı Satışı',
  'blog.seoCard1Desc': 'Dünya genelinde <strong>toptan halı satışı</strong> alanında güvenilir tedarikçi olarak, kaliteli ürünlerimizi 50\'den fazla ülkeye ihraç ediyoruz.',
  'blog.seoCard2Title': 'Halı Ihracatı',
  'blog.seoCard2Desc': 'Gaziantep\'ten dünyaya uzanan <strong>halı ihracatı</strong> ağımızla, uluslararası standartlarda üretim yapıyor ve global pazarda güçlü konumumuzu koruyoruz.',
  'blog.seoCard3Title': 'Kalite Sertifikaları',
  'blog.seoCard3Desc': 'ISO 9001 ve uluslararası kalite sertifikalarımızla <strong>halı üretiminde</strong> en yüksek standartları uygulayarak müşterilerimize güven veriyoruz.',
  'blog.faqTitle': 'Sıkça Sorulan Sorular',
  'blog.faq1Q': 'Toptan halı satışı için minimum sipariş miktarı nedir?',
  'blog.faq1A': 'Toptan halı satışlarımızda minimum sipariş miktarı koleksiyona göre değişmektedir. Detaylı bilgi için satış ekibimizle iletişime geçebilirsiniz.',
  'blog.faq2Q': 'Halı ihracatı için hangi ülkelere teslimat yapıyorsunuz?',
  'blog.faq2A': 'Avrupa, Orta Doğu, Asya ve Afrika dahil 50\'den fazla ülkeye halı ihracatı gerçekleştiriyoruz. Ülkenize özel teslimat koşulları için bizimle iletişime geçin.',
  'blog.faq3Q': 'Halı üretim süreciniz hakkında bilgi alabilir miyim?',
  'blog.faq3A': 'Modern makineler ve usta ellerin bir araya geldiği üretim tesisimizde, hammaddeden son ürüne kadar her aşama titizlikle kontrol edilmektedir.',

  // Wholesale Carpet Production Page
  'wholesale.heroLabel': 'Toptan Halı Üretimi & Global Ticaret',
  'wholesale.heroTitle': 'Toptan Halı Üretimi ve Global Halı Ticareti',
  'wholesale.heroSubtitle': 'Gaziantep\'ten dünyaya uzanan toptan halı üretimi gücümüzle, 50\'den fazla ülkeye kaliteli halı ihracatı gerçekleştiriyoruz. Halı toptancısı olarak global pazarda güvenilir çözüm ortağınızız.',
  'wholesale.heroAlt': 'Toptan Halı Üretimi Fabrika',
  'wholesale.ctaContact': 'İletişime Geçin',
  'wholesale.ctaCollections': 'Koleksiyonları İncele',

  'wholesale.stat1': 'İhracat Ülkesi',
  'wholesale.stat2': 'm² Yıllık Üretim',
  'wholesale.stat3': 'Yıllık Tecrübe',
  'wholesale.stat4': 'Uzman Çalışan',

  'wholesale.introLabel': 'Hakkımızda',
  'wholesale.introTitle': 'Türkiye\'nin Önde Gelen Halı Toptancısı',
  'wholesale.introP1': 'MONS HALI olarak 30 yılı aşkın tecrübemizle Türkiye\'nin en köklü toptan halı üreticileri arasında yer alıyoruz. Gaziantep\'teki modern üretim tesislerimizde günlük binlerce metrekare halı üretimi gerçekleştiriyor, dünya genelindeki halı toptancıları ve distribütörlerine kesintisiz tedarik sağlıyoruz.',
  'wholesale.introP2': 'Toptan halı satışı alanında sunduğumuz geniş ürün yelpazesi; makine halısı, el halısı, modern tasarımlar ve klasik koleksiyonları kapsamaktadır. Her müşteriin ihtiyacına özel çözümler üretir, minimum sipariş miktarlarında esneklik sağlarız.',
  'wholesale.introP3': 'ISO 9001 sertifikalı üretim süreçlerimiz, OEKO-TEX standartlarına uygun hammadde kullanımımız ve sıkı kalite kontrol mekanizmalarımızla halı ihracatında güvenilir bir marka olarak öne çıkıyoruz.',
  'wholesale.isoCertified': 'Sertifikalı Üretim',

  'wholesale.processLabel': 'Üretim Süreci',
  'wholesale.processTitle': 'Toptan Halı Üretim Süreçleri',
  'wholesale.processSubtitle': 'Hammaddeden son ürüne kadar her aşamada kalite ve titizlik. Toptan halı üretimimizde uygulanan 5 temel süreç.',
  'wholesale.processBannerTitle': 'Uçtan Uca Üretim Kontrolü',
  'wholesale.processBannerDesc': 'Hammadde seçiminden paketlemeye kadar her aşama uzman ekibimiz tarafından denetlenmektedir.',
  'wholesale.process1Title': 'Hammadde Seçimi',
  'wholesale.process1Desc': 'Yüksek kaliteli iplik ve doğal lifler titizlikle seçilir, kalite testlerinden geçirilir.',
  'wholesale.process2Title': 'Dokuma & Üretim',
  'wholesale.process2Desc': 'Son teknoloji makineler ve usta ellerin birleşimiyle halılar üretilir.',
  'wholesale.process3Title': 'Boyama & Renklendirme',
  'wholesale.process3Desc': 'Çevre dostu boyalar kullanılarak canlı ve kalıcı renkler elde edilir.',
  'wholesale.process4Title': 'Kalite Kontrol',
  'wholesale.process4Desc': 'Her halı çok aşamalı kalite testlerinden geçirilir, standartlar doğrulanır.',
  'wholesale.process5Title': 'Paketleme & Sevkiyat',
  'wholesale.process5Desc': 'Özel ambalajlama ile ürünler güvenle paketlenir ve dünyaya gönderilir.',

  'wholesale.typesLabel': 'Halı Türleri',
  'wholesale.typesTitle': 'Makine Halısı ve El Halısı Farkları',
  'wholesale.typesSubtitle': 'Toptan halı satışımızda sunduğumuz iki ana üretim kategorisi: modern makine halıları ve geleneksel el dokuması halılar.',
  'wholesale.machineCarpetTitle': 'Makine Halısı',
  'wholesale.machineCarpetDesc': 'Yüksek teknolojili dokuma makineleriyle üretilen makine halıları, toptan halı satışında en çok tercih edilen kategoridir. Standart boyutlar, geniş renk seçenekleri ve rekabetçi fiyatlarıyla büyük hacimli siparişler için idealdir. Günlük binlerce metrekare üretim kapasitesiyle hızlı teslimat imkânı sunar.',
  'wholesale.handCarpetTitle': 'El Halısı',
  'wholesale.handCarpetDesc': 'Usta halı ustalarının elinden çıkan el dokuması halılar, eşsiz desen ve dokusuyla premium segmentte öne çıkar. Her biri bir sanat eseri olan el halıları; oteller, butik mağazalar ve özel projeler için tercih edilir. Toptan el halısı siparişlerinde özel tasarım ve boyut seçenekleri sunulmaktadır.',
  'wholesale.tag.fast': 'Hızlı Üretim',
  'wholesale.tag.uniform': 'Standart Kalite',
  'wholesale.tag.affordable': 'Rekabetçi Fiyat',
  'wholesale.tag.unique': 'Eşsiz Tasarım',
  'wholesale.tag.artisan': 'El İşçiliği',
  'wholesale.tag.premium': 'Premium Segment',

  'wholesale.qualityLabel': 'Kalite Kontrol',
  'wholesale.qualityTitle': 'Halı Üretiminde Kalite Kontrol',
  'wholesale.qualitySubtitle': 'Toptan halı üretimimizde uygulanan çok aşamalı kalite kontrol süreçleri, her ürünün uluslararası standartları karşılamasını garanti eder.',
  'wholesale.quality1Title': 'Hammadde Analizi',
  'wholesale.quality1Desc': 'Üretimde kullanılan tüm iplik ve lifler, akredite laboratuvarlarda fiziksel ve kimyasal testlere tabi tutulur. OEKO-TEX sertifikası gerektiren standartlar titizlikle uygulanır.',
  'wholesale.quality2Title': 'Üretim Sürecinde Kontrol',
  'wholesale.quality2Desc': 'Dokuma, boyama ve bitirme aşamalarında anlık kalite kontrolleri yapılır. Renk tutarlılığı, desen hassasiyeti ve yüzey kalitesi sürekli izlenir.',
  'wholesale.quality3Title': 'Son Ürün Denetimi',
  'wholesale.quality3Desc': 'Tamamlanan her halı, boyut doğruluğu, yüzey kusurları ve dayanıklılık açısından kapsamlı son kontrolden geçirilir. Standartları karşılamayan ürünler sevkiyata alınmaz.',
  'wholesale.quality4Title': 'Uluslararası Sertifikasyon',
  'wholesale.quality4Desc': 'ISO 9001 Kalite Yönetim Sistemi, OEKO-TEX Standard 100 ve CE sertifikalarımızla toptan halı ihracatında uluslararası güvence sağlıyoruz.',
  'wholesale.qualityBannerTitle': 'Sıfır Hata Politikası',
  'wholesale.qualityBannerDesc': 'Her toptan halı siparişinde %100 kalite güvencesi. Uluslararası standartlara uygunluk belgelerimizle güvenle ihracat yapıyoruz.',

  'wholesale.exportLabel': 'Lojistik & İhracat',
  'wholesale.exportTitle': 'Lojistik ve İhracat Süreci',
  'wholesale.exportSubtitle': 'Gaziantep\'ten dünyaya uzanan halı ihracatı ağımızla, 50\'den fazla ülkeye güvenli ve zamanında teslimat gerçekleştiriyoruz.',
  'wholesale.exportMapTitle': 'Global Halı İhracat Ağı',
  'wholesale.exportMapDesc': 'Avrupa, Orta Doğu, Asya ve Afrika\'da 50+ ülkeye toptan halı ihracatı',
  'wholesale.region.europe': 'Avrupa',
  'wholesale.region.middleEast': 'Orta Doğu',
  'wholesale.region.asia': 'Asya',
  'wholesale.region.africa': 'Afrika',
  'wholesale.logisticsTitle': 'Güvenli Lojistik & Hızlı Teslimat',
  'wholesale.logisticsDesc': 'Özel ambalajlama, sigortalı kargo ve kapıdan kapıya teslimat seçenekleriyle toptan halı siparişleriniz güvenle ulaşır.',

  'wholesale.turkeyLabel': 'Türkiye\'nin Gücü',
  'wholesale.turkeyTitle': 'Türkiye\'nin Halı Üretim Gücü',
  'wholesale.turkeyP1': 'Türkiye, dünya halı ihracatında lider konumuyla global pazarda belirleyici bir güçtür. Gaziantep başta olmak üzere Türkiye\'nin halı üretim merkezleri, yıllık milyarlarca dolarlık ihracat hacmiyle dünya ekonomisine katkı sağlamaktadır.',
  'wholesale.turkeyP2': 'Türk halı sektörü; geleneksel el sanatlarını modern üretim teknolojileriyle harmanlayarak eşsiz ürünler ortaya koymaktadır. Toptan halı üretiminde Türkiye\'nin sunduğu rekabetçi fiyat, yüksek kalite ve geniş tasarım yelpazesi, global halı toptancılarının ilk tercihi olmayı sürdürmektedir.',
  'wholesale.turkeyP3': 'MONS HALI olarak bu güçlü sektörün öncü temsilcilerinden biri olarak, Türk halı sanatını dünyaya taşıma misyonumuzu kararlılıkla sürdürüyoruz. Halı ihracatında Türkiye\'nin markası olmak için her gün çalışıyoruz.',
  'wholesale.turkeyRank': 'Dünya Halı İhracatında',
  'wholesale.turkeyFact1': 'Dünya Halı İhracatı Payı',
  'wholesale.turkeyFact2': 'Yıllık İhracat Değeri',
  'wholesale.turkeyFact3': 'Ülkeye İhracat',

  'wholesale.distLabel': 'Distribütörlük',
  'wholesale.distTitle': 'Global Halı Satışı ve Distribütörlük Sistemi',
  'wholesale.distSubtitle': 'Dünya genelinde halı toptancıları ve distribütörlerimizle kurduğumuz güçlü iş ortaklıkları, global halı satışıımızın temelini oluşturmaktadır.',
  'wholesale.dist1Title': 'Yerel Bayi Ağı',
  'wholesale.dist1Desc': 'Türkiye genelinde 170\'den fazla aktif bayimizle güçlü bir yerel satış ağı oluşturuyoruz. Bayilerimize özel fiyatlandırma, pazarlama desteği ve eğitim programları sunuyoruz.',
  'wholesale.dist2Title': 'Uluslararası Distribütörler',
  'wholesale.dist2Desc': '50\'den fazla ülkedeki yetkili distribütörlerimiz aracılığıyla global halı satışı gerçekleştiriyoruz. Her bölge için özelleştirilmiş ticaret koşulları ve lojistik çözümler sunuyoruz.',
  'wholesale.dist3Title': 'Kurumsal & Proje Satışları',
  'wholesale.dist3Desc': 'Oteller, alışveriş merkezleri, ofisler ve kamu projeleri için özel toptan halı çözümleri üretiyoruz. Büyük hacimli projelerde rekabetçi fiyat ve hızlı teslimat garantisi veriyoruz.',

  'wholesale.faqLabel': 'SSS',
  'wholesale.faqTitle': 'Sıkça Sorulan Sorular',
  'wholesale.faq1Q': 'Toptan halı üretiminde minimum sipariş miktarı nedir?',
  'wholesale.faq1A': 'Toptan halı siparişlerinde minimum miktar, koleksiyona ve ürün tipine göre değişmektedir. Makine halısı siparişlerinde genellikle 100 m² ve üzeri siparişlerde toptan fiyat avantajı sunulmaktadır. Detaylı bilgi için satış ekibimizle iletişime geçebilirsiniz.',
  'wholesale.faq2Q': 'Halı ihracatı için hangi ülkelere teslimat yapıyorsunuz?',
  'wholesale.faq2A': 'Avrupa, Orta Doğu, Asya ve Afrika dahil 50\'den fazla ülkeye halı ihracatı gerçekleştiriyoruz. Ülkenize özel teslimat koşulları için bizimle iletişime geçin.',
  'wholesale.faq3Q': 'Makine halısı ile el halısı arasındaki temel farklar nelerdir?',
  'wholesale.faq3A': 'Makine halıları yüksek hızlı dokuma makineleriyle üretilir; standart kalite, hızlı teslimat ve rekabetçi fiyat sunar. El halıları ise usta ustalar tarafından elle dokunur; her biri benzersizdir, daha uzun üretim süresi gerektirir ve premium fiyat segmentinde yer alır. Toptan halı siparişlerinde her iki kategori için de geniş stok imkânı sunuyoruz.',
  'wholesale.faq4Q': 'Toptan halı siparişlerinde ödeme koşulları nasıldır?',
  'wholesale.faq4A': 'Toptan halı alımlarında esnek ödeme seçenekleri sunuyoruz: peşin ödemede ek indirim, 30-60-90 gün vadeli ödeme seçenekleri ve ihracat siparişleri için akreditif imkânı mevcuttur. Uzun vadeli iş ortaklarımıza özel kredi limitleri tanınmaktadır.',
  'wholesale.faq5Q': 'Özel tasarım toptan halı siparişi verebilir miyim?',
  'wholesale.faq5A': 'Evet, kurumsal müşterilerimiz ve büyük hacimli alıcılar için özel tasarım, renk ve boyutlarda toptan halı üretimi yapabiliyoruz. Logolu halılar, özel desen ve renk kombinasyonları için minimum sipariş miktarları uygulanmaktadır. Proje detaylarınızı paylaşmak için satış ekibimizle görüşebilirsiniz.',

  'wholesale.ctaTitle': 'Toptan Halı Siparişi için Bizimle İletişime Geçin',
  'wholesale.ctaDesc': 'Halı toptancısı olarak dünya genelinde güvenilir tedarik çözümleri sunuyoruz. Toptan halı satışı, halı ihracatı ve distribütörlük için hemen iletişime geçin.',

  // Gaziantep Carpet Page
  'gaziantepCarpet.heroLabel': 'Gaziantep Halı Fabrikası',
  'gaziantepCarpet.heroTitle': 'Gaziantep Carpet: Dünyaya Açılan Halı Fabrikası',
  'gaziantepCarpet.heroSubtitle': 'Gaziantep\'in güçlü halı üretim altyapısı ve lojistik avantajlarıyla, toptan halı toptancısı olarak 80\'den fazla ülkeye kaliteli halı ihracatı gerçekleştiriyoruz.',
  'gaziantepCarpet.heroAlt': 'Gaziantep Halı Fabrikası Panorama',
  'gaziantepCarpet.ctaContact': 'İletişime Geçin',
  'gaziantepCarpet.ctaCollections': 'Koleksiyonları İncele',

  'gaziantepCarpet.stat1': 'Halı Fabrikası',
  'gaziantepCarpet.stat2': 'm² Yıllık Üretim',
  'gaziantepCarpet.stat3': 'İhracat Ülkesi',
  'gaziantepCarpet.stat4': 'Yıllık Tecrübe',

  'gaziantepCarpet.introLabel': 'Hakkımızda',
  'gaziantepCarpet.introTitle': 'Gaziantep Toptan Halı Üretiminde Lider Fabrika',
  'gaziantepCarpet.introP1': 'Gaziantep, Türkiye\'nin en büyük halı üretim merkezi olarak dünya genelinde tanınan bir sanayi şehridir. 500\'den fazla halı fabrikasıyla Gaziantep, yıllık 2 milyon metrekarenin üzerinde halı üretim kapasitesine sahiptir. MONS HALI olarak bu güçlü ekosistemin içinde, modern üretim tesislerimizle toptan halı üretiminde öncü konumdayız.',
  'gaziantepCarpet.introP2': 'Gaziantep halı fabrikaları arasında öne çıkan üretim kapasitemiz, geniş ürün yelpazemiz ve rekabetçi toptan halı fiyatlarımızla hem yerel hem de uluslararası alıcılara kesintisiz tedarik sağlıyoruz. Halı toptancısı olarak sunduğumuz hizmetler; makine halısı, el halısı ve özel ölçü halı üretimi içerir.',
  'gaziantepCarpet.introP3': 'ISO 9001 sertifikalı üretim süreçlerimiz ve OEKO-TEX standartlarına uygun hammadde kullanımımızla, Gaziantep halı ihracatında güvenilir bir marka olarak global pazarda güçlü konumumuzu koruyoruz.',
  'gaziantepCarpet.isoCertified': 'ISO 9001 Sertifikalı',
  'gaziantepCarpet.badge1': 'Toptan Halı Üretimi',
  'gaziantepCarpet.badge2': 'Halı İhracatı',
  'gaziantepCarpet.badge3': 'Wholesale Carpet',

  'gaziantepCarpet.factoryBannerTitle': 'Gaziantep\'in Kalbi: Halı Üretim Merkezi',
  'gaziantepCarpet.factoryBannerDesc': 'Gaziantep\'teki modern fabrika tesislerimizde günlük binlerce metrekare halı üretimi gerçekleştiriliyor. Türkiye\'nin halı ihracatının %60\'ından fazlası Gaziantep\'ten yapılmaktadır.',
  'gaziantepCarpet.factoryBannerAlt': 'Gaziantep Halı Fabrikası Panorama',

  'gaziantepCarpet.advLabel': 'Neden Biz?',
  'gaziantepCarpet.advTitle': 'Gaziantep Halı Üretiminin Gücü',
  'gaziantepCarpet.advSubtitle': 'Toptan halı alımlarında Gaziantep\'teki fabrikamızın sunduğu rekabetçi avantajları keşfedin.',
  'gaziantepCarpet.adv1Title': 'Yüksek Üretim Kapasitesi',
  'gaziantepCarpet.adv1Desc': 'Günlük binlerce metrekare üretim kapasitesiyle büyük hacimli toptan halı siparişlerini zamanında karşıılıyoruz.',
  'gaziantepCarpet.adv2Title': 'Güçlü Lojistik Altyapı',
  'gaziantepCarpet.adv2Desc': 'Gaziantep\'in stratejik konumu ve gelişmiş lojistik ağıyla Avrupa, Orta Doğu ve Asya\'da güvenilir teslimat sağlıyoruz.',
  'gaziantepCarpet.adv3Title': 'Rekabetçi Toptan Halı Fiyat',
  'gaziantepCarpet.adv3Desc': 'Fabrikadan direkt satış avantajıyla piyasanın en rekabetçi toptan halı fiyatlarını sunuyoruz.',
  'gaziantepCarpet.adv4Title': 'Geniş Tasarım Yelpazesi',
  'gaziantepCarpet.adv4Desc': 'Modern, klasik, etnik ve minimalist tasarımlardan oluşan geniş koleksiyonumuzla her pazara uygun ürün sunuyoruz.',
  'gaziantepCarpet.adv5Title': 'Uluslararası Kalite Standartları',
  'gaziantepCarpet.adv5Desc': 'ISO 9001 ve OEKO-TEX sertifikalarımızla uluslararası kalite standartlarını karşılayan halı üretimi yapıyoruz.',
  'gaziantepCarpet.adv6Title': '7/24 Satış Desteği',
  'gaziantepCarpet.adv6Desc': 'Uzman satış ekibimiz toptan halı siparişleriniz için 7/24 destek sağlıyor, özel teklifler hazırlıyor.',

  'gaziantepCarpet.prodLabel': 'Ürün Kategorileri',
  'gaziantepCarpet.prodTitle': 'Toptan Halı Ürün Kategorileri',
  'gaziantepCarpet.prodSubtitle': 'Gaziantep fabrikamızda üretilen üç ana halı kategorisi: makine halısı, el halısı ve özel ölçü halı.',
  'gaziantepCarpet.prod1Title': 'Makine Halısı Üretimi',
  'gaziantepCarpet.prod1Desc': 'Yüksek teknolojili dokuma makineleriyle üretilen makine halıları, toptan halı satışında en çok tercih edilen kategoridir. Standart boyutlar, geniş renk seçenekleri ve rekabetçi fiyatlarıyla büyük hacimli siparişler için idealdir. Günlük binlerce metrekare üretim kapasitesiyle hızlı teslimat imkânı sunar.',
  'gaziantepCarpet.prod2Title': 'El Halısı Üretimi',
  'gaziantepCarpet.prod2Desc': 'Usta halı ustalarının elinden çıkan el dokuması halılar, eşsiz desen ve dokusuyla premium segmentte öne çıkar. Her biri bir sanat eseri olan el halıları; oteller, butik mağazalar ve özel projeler için tercih edilir. Toptan el halısı siparişlerinde özel tasarım ve boyut seçenekleri sunulmaktadır.',
  'gaziantepCarpet.prod3Title': 'Özel Ölçü Halı Üretimi',
  'gaziantepCarpet.prod3Desc': 'Kurumsal müşteriler ve büyük projeler için özel boyut, renk ve tasarımda toptan halı üretimi yapıyoruz. Logolu halılar ve özel koleksiyonlar için minimum sipariş miktarları uygulanmaktadır.',
  'gaziantepCarpet.tag.machine': 'Makine Halısı',
  'gaziantepCarpet.tag.bulk': 'Toplu Sipariş',
  'gaziantepCarpet.tag.fast': 'Hızlı Teslimat',
  'gaziantepCarpet.tag.handmade': 'El Dokuması',
  'gaziantepCarpet.tag.premium': 'Premium',
  'gaziantepCarpet.tag.unique': 'Eşsiz Tasarım',
  'gaziantepCarpet.tag.modern': 'Modern Tasarım',
  'gaziantepCarpet.tag.custom': 'Özel Üretim',
  'gaziantepCarpet.tag.export': 'İhracat',

  'gaziantepCarpet.logisticsBannerTitle': 'Gaziantep\'ten Dünyaya: Güvenli Lojistik & Hızlı Teslimat',
  'gaziantepCarpet.logisticsBannerDesc': 'Özel ambalajlama, sigortalı kargo ve kapıdan kapıya teslimat seçenekleriyle toptan halı siparişleriniz güvenle ulaşır. Gaziantep\'in lojistik altyapısı ihracatı kolaylaştırır.',
  'gaziantepCarpet.logisticsBannerAlt': 'Halı Lojistik ve Depolama',

  'gaziantepCarpet.exportLabel': 'Global İhracat',
  'gaziantepCarpet.exportTitle': 'Türkiye\'den Dünyaya Halı İhracatı',
  'gaziantepCarpet.exportSubtitle': 'Gaziantep\'ten 80\'den fazla ülkeye gerçekleştirdiğimiz halı ihracatıyla global pazarda güçlü konumumuzu koruyoruz.',
  'gaziantepCarpet.exportMapTitle': 'Global Halı İhracat Ağı',
  'gaziantepCarpet.exportMapDesc': 'Avrupa, Orta Doğu, Asya ve Afrika\'da 80+ ülkeye toptan halı ihracatı',
  'gaziantepCarpet.market1': 'Avrupa',
  'gaziantepCarpet.market2': 'Orta Doğu',
  'gaziantepCarpet.market3': 'Asya',
  'gaziantepCarpet.market4': 'Afrika',

  'gaziantepCarpet.whyLabel': 'Neden Gaziantep?',
  'gaziantepCarpet.whyTitle': 'Gaziantep Halı Üretiminin Gücü',
  'gaziantepCarpet.whyP1': 'Gaziantep, Türkiye\'nin halı ihracatının %60\'ından fazlasını gerçekleştiren, dünyanın en önemli halı üretim merkezlerinden biridir. Şehirdeki 500\'den fazla halı fabrikası, yıllık milyarlarca dolarlık ihracat hacmiyle global ekonomiye katkı sağlamaktadır.',
  'gaziantepCarpet.whyP2': 'Gaziantep halı fabrikaları; geleneksel Türk halı sanatını modern üretim teknolojileriyle harmanlayarak eşsiz ürünler ortaya koymaktadır. Toptan halı fiyatlarında rekabetçi avantaj, yüksek kalite ve geniş tasarım yelpazesiyle Gaziantep, global halı toptancılarının ilk tercihi olmaya devam etmektedir.',
  'gaziantepCarpet.whyP3': 'MONS HALI olarak Gaziantep\'in bu güçlü halı üretim ekosisteminin öncü temsilcilerinden biri olarak, Türk halı sanatını dünyaya taşıma misyonumuzu kararlılıkla sürdürüyoruz.',
  'gaziantepCarpet.whyFact1': 'Halı Fabrikası',
  'gaziantepCarpet.whyFact2': 'Türkiye İhracat Payı',
  'gaziantepCarpet.whyFact3': 'Yıllık İhracat Değeri',
  'gaziantepCarpet.whyRank': 'Türkiye Halı İhracatında',

  'gaziantepCarpet.wholesaleLabel': 'Toptan Halı Satışı',
  'gaziantepCarpet.wholesaleTitle': 'Gaziantep Toptan Halı Satışı ve Distribütörlük',
  'gaziantepCarpet.wholesaleSubtitle': 'Fabrikadan direkt toptan halı satışı ile rekabetçi fiyat avantajı. Yerel ve uluslararası distribütörler için özel ticaret koşulları.',
  'gaziantepCarpet.wholesaleP1': 'Gaziantep\'teki fabrikamızdan direkt toptan halı satışı yaparak aracı maliyetlerini ortadan kaldırıyor, alıcılarımıza en rekabetçi toptan halı fiyatlarını sunuyoruz. Makine halısı, el halısı ve özel ölçü halı kategorilerinde geniş stok imkânı mevcuttur.',
  'gaziantepCarpet.wholesaleP2': 'Uluslararası halı toptancıları ve distribütörlerimizle kurduğumuz uzun vadeli iş ortaklıkları, global halı satışıımızın temelini oluşturmaktadır. Her bölge için özelleştirilmiş ticaret koşulları ve lojistik çözümler sunuyoruz.',
  'gaziantepCarpet.wholesaleP3': 'Toptan halı alımlarında esnek ödeme seçenekleri, hızlı teslimat garantisi ve satış sonrası destek hizmetlerimizle iş ortaklarımızın yanında olmaya devam ediyoruz.',
  'gaziantepCarpet.wholesaleFeature1': 'Fabrikadan direkt toptan halı fiyatı avantajı',
  'gaziantepCarpet.wholesaleFeature2': 'Minimum sipariş miktarında esneklik',
  'gaziantepCarpet.wholesaleFeature3': 'Özel tasarım ve renk seçenekleri',
  'gaziantepCarpet.wholesaleFeature4': 'Uluslararası lojistik ve gümrük desteği',

  'gaziantepCarpet.faqLabel': 'SSS',
  'gaziantepCarpet.faqTitle': 'Sıkça Sorulan Sorular',
  'gaziantepCarpet.faq1Q': 'Gaziantep\'ten toptan halı alımında minimum sipariş miktarı nedir?',
  'gaziantepCarpet.faq1A': 'Toptan halı siparişlerinde minimum miktar, ürün tipine göre değişmektedir. Makine halısı siparişlerinde genellikle 100 m² ve üzeri siparişlerde toptan fiyat avantajı sunulmaktadır. Detaylı bilgi için satış ekibimizle iletişime geçebilirsiniz.',
  'gaziantepCarpet.faq2Q': 'Gaziantep halı fabrikasından ihracat yapıyor musunuz?',
  'gaziantepCarpet.faq2A': 'Evet, Gaziantep fabrikamızdan Avrupa, Orta Doğu, Asya ve Afrika dahil 80\'den fazla ülkeye halı ihracatı gerçekleştiriyoruz. Almanya, Fransa, BAE, Suudi Arabistan başlıca ihracat pazarlarımız arasındadır.',
  'gaziantepCarpet.faq3Q': 'Toptan halı fiyatları nasıl belirleniyor?',
  'gaziantepCarpet.faq3A': 'Toptan halı fiyatları; sipariş miktarı, ürün tipi, tasarım karmaşıklığı ve teslimat koşullarına göre belirlenmektedir. Fabrikadan direkt satış avantajıyla piyasanın en rekabetçi fiyatlarını sunuyoruz.',
  'gaziantepCarpet.faq4Q': 'Özel tasarım halı üretimi yapıyor musunuz?',
  'gaziantepCarpet.faq4A': 'Evet, kurumsal müşterilerimiz için özel tasarım, renk ve boyutlarda toptan halı üretimi yapabiliyoruz. Logolu halılar ve özel koleksiyonlar için minimum sipariş miktarları uygulanmaktadır.',
  'gaziantepCarpet.faq5Q': 'Gaziantep halı fabrikasını ziyaret edebilir miyim?',
  'gaziantepCarpet.faq5A': 'Evet, fabrika ziyaretleri için önceden randevu almanız gerekmektedir. Üretim sürecimizi yerinde görmek isteyen alıcılarımıza fabrika turu düzenliyoruz. Randevu için iletişim formumuzdan bize ulaşabilirsiniz.',

  'gaziantepCarpet.ctaTitle': 'Gaziantep\'ten Toptan Halı Siparişi için Bizimle İletişime Geçin',
  'gaziantepCarpet.ctaDesc': 'Halı toptancısı ve wholesale carpet manufacturer olarak dünya genelinde güvenilir tedarik çözümleri sunuyoruz. Toptan halı satışı ve halı ihracatı için hemen iletişime geçin.',

  'product.carpet001.name': 'Gri Balıksırtı Desenli Halı',
  'product.carpet001.description': 'Modern ve şık tasarımıyla mekanlarınıza zarafet katan gri tonlarında balıksırtı desenli halı',
  'product.carpet002.name': 'Bej Balıksırtı Desenli Halı',
  'product.carpet002.description': 'Sıcak ve doğal bej tonlarında, her mekana uyum sağlayan klasik balıksırtı desenli halı',
  'product.carpet003.name': 'Antrasit Balıksırtı Desenli Halı',
  'product.carpet003.description': 'Koyu ve sofistike antrasit rengiyle modern mekanlara mükemmel uyum sağlayan halı',
  'product.carpet004.name': 'Krem Balıksırtı Desenli Halı',
  'product.carpet004.description': 'Aydınlık ve ferah mekanlar için ideal, krem rengi balıksırtı desenli şık halı',
  'product.carpet005.name': 'Kahverengi Balıksırtı Desenli Halı',
  'product.carpet005.description': 'Sıcak kahverengi tonuyla rustik ve modern mekanlara uygun zarif halı',
  'product.carpet006.name': 'Lacivert Balıksırtı Desenli Halı',
  'product.carpet006.description': 'Derin lacivert rengiyle lüks ve sofistike bir görünüm sunan zarif halı',
  'product.carpet007.name': 'Yeşil Balıksırtı Desenli Halı',
  'product.carpet007.description': 'Doğal yeşil tonuyla ferah ve huzurlu bir atmosfer yaratan halı',
  'product.carpet008.name': 'Pembe Balıksırtı Desenli Halı',
  'product.carpet008.description': 'Yumuşak pembe tonuyla romantik ve zarif bir dokunuş katan halı',
  'product.carpet009.name': 'Bordo Balıksırtı Desenli Halı',
  'product.carpet009.description': 'Zengin bordo rengiyle klasik ve lüks mekanlara özel tasarım halı',
  'product.carpet010.name': 'Turkuaz Balıksırtı Desenli Halı',
  'product.carpet010.description': 'Canlı turkuaz rengiyle modern ve enerjik mekanlara dinamizm katan halı',
  'product.carpet011.name': 'Hardal Sarısı Balıksırtı Desenli Halı',
  'product.carpet011.description': 'Sıcak hardal sarısı tonuyla neşeli ve modern bir atmosfer yaratan halı',
  'product.carpet012.name': 'Turuncu Balıksırtı Desenli Halı',
  'product.carpet012.description': 'Enerjik turuncu rengiyle dinamik ve cesur mekanlara özel tasarım halı',
  'product.carpet013.name': 'Mor Balıksırtı Desenli Halı',
  'product.carpet013.description': 'Zarif mor tonuyla sofistike ve lüks mekanlara uygun özel halı',
  'product.carpet014.name': 'Duman Grisi Balıksırtı Desenli Halı',
  'product.carpet014.description': 'Nötr duman grisi tonuyla her mekana uyum sağlayıcı çok yönlü halı',
  'product.carpet015.name': 'Taş Grisi Balıksırtı Desenli Halı',
  'product.carpet015.description': 'Doğal taş grisi tonuyla minimalist ve modern mekanlara uygun halı',
  'product.carpet016.name': 'Ekru Balıksırtı Desenli Halı',
  'product.carpet016.description': 'Sıcak ekru tonuyla klasik ve modern mekanlara uyum sağlayıcı zarif halı',
  'product.carpet017.name': 'Vizon Balıksırtı Desenli Halı',
  'product.carpet017.description': 'Şık vizon rengiyle lüks ve zarif mekanlara özel premium halı',
  'product.carpet018.name': 'Siyah Balıksırtı Desenli Halı',
  'product.carpet018.description': 'Klasik siyah rengiyle modern ve minimalist mekanlara sofistike bir dokunuş',
  'product.carpet019.name': 'Beyaz Balıksırtı Desenli Halı',
  'product.carpet019.description': 'Saf beyaz rengiyle aydınlık ve ferah mekanlar için ideal minimalist halı',
  'product.carpet020.name': 'Gümüş Grisi Balıksırtı Desenli Halı',
  'product.carpet020.description': 'Parlak gümüş grisi tonuyla lüks ve modern mekanlara glamour katan halı',
  'product.carpet021.name': 'Altın Sarısı Balıksırtı Desenli Halı',
  'product.carpet021.description': 'Zengin altın sarısı tonuyla gösterişli ve lüks mekanlara özel prestijli halı',
  'product.carpet022.name': 'Bronz Balıksırtı Desenli Halı',
  'product.carpet022.description': 'Sıcak bronz tonuyla klasik ve modern mekanlara zamansız bir zarafet katan halı',
  'product.carpet023.name': 'Bakır Balıksırtı Desenli Halı',
  'product.carpet023.description': 'Canlı bakır rengiyle modern ve enerjik mekanlara dinamik bir görünüm sunan halı',
  'product.carpet024.name': 'Zeytin Yeşili Balıksırtı Desenli Halı',
  'product.carpet024.description': 'Doğal zeytin yeşili tonuyla huzurlu ve organik mekanlara uygun halı',
  'product.carpet025.name': 'Çimen Yeşili Balıksırtı Desenli Halı',
  'product.carpet025.description': 'Taze çimen yeşili tonuyla canlı ve enerjik mekanlara ferahlık katan halı',
  'product.carpet026.name': 'Deniz Mavisi Balıksırtı Desenli Halı',
  'product.carpet026.description': 'Sakin deniz mavisi tonuyla huzurlu ve sahil temalı mekanlara uygun halı',
  'product.carpet027.name': 'Gök Mavisi Balıksırtı Desenli Halı',
  'product.carpet027.description': 'Açık gök mavisi tonuyla aydınlık ve ferah mekanlara taze bir dokunuş katan halı',
  'product.carpet028.name': 'Lavanta Moru Balıksırtı Desenli Halı',
  'product.carpet028.description': 'Yumuşak lavanta moru tonuyla romantik ve huzurlu mekanlara uygun zarif halı',
  'product.carpet029.name': 'Mercan Pembe Balıksırtı Desenli Halı',
  'product.carpet029.description': 'Canlı mercan pembe tonuyla enerjik ve neşeli mekanlara dinamizm katan halı',
  'product.carpet030.name': 'Şeftali Rengi Balıksırtı Desenli Halı',
  'product.carpet030.description': 'Tatlı şeftali rengiyle sıcak ve davetkar mekanlara konforlu bir atmosfer katan halı',

  'product.feature.material': 'Materyal',
  'product.feature.production': 'Üretim',
  'product.feature.pileHeight': 'Hav Yüksekliği',
  'product.feature.base': 'Taban',

  'product.value.polypropylene': 'Polipropilen',
  'product.value.flatWeave': 'Düz Dokuma',
  'product.value.machineWoven': 'Makine Dokuma',
  'product.value.jute': 'Jüt',
  'product.value.lowPile': 'Düşük Hav',
  'product.value.mediumPile': 'Orta Hav',
  'product.value.highPile': 'Yüksek Hav',

  'product.modal.prevProduct': 'Önceki Ürün',
  'product.modal.nextProduct': 'Sonraki Ürün',
  'product.modal.sizesTitle': 'Ebatlar ve Ölçüler',
  'product.modal.featuresTitle': 'Ürün Özellikleri',
  'product.modal.productCode': 'Ürün Kodu',
  'product.modal.backToPage': 'Sayfaya Geri Dön',
  'product.modal.zoomHint': 'Görsele tıklayarak yakınlaştırabilirsiniz',
  'product.modal.fullscreenHint': 'Çift tıklayarak yakınlaştırın · Scroll ile zoom · Sürükleyerek kaydırın',
  'product.modal.fullscreen': 'Tam Ekran',

  // Home Blog Posts (ana sayfada gösterilen 3 yazı)
  'blog.home101.title': 'Tekstil Sektöründe Sürdürülebilirlik',
  'blog.home101.excerpt': 'Çevre dostu üretim süreçlerimiz ve sürdürülebilir tekstil anlayışımız hakkında detaylı bilgiler.',
  'blog.home101.date': '15 Mart 2024',
  'blog.home101.readTime': '5 dk',
  'blog.home102.title': '2024 Tekstil Trendleri',
  'blog.home102.excerpt': 'Yeni sezon tekstil trendleri ve renk paletleri hakkında uzman görüşleri ve öngörüler.',
  'blog.home102.date': '10 Mart 2024',
  'blog.home102.readTime': '7 dk',
  'blog.home103.title': 'Kalite Kontrol Süreçlerimiz',
  'blog.home103.excerpt': 'Ürünlerimizin en yüksek kalite standartlarını karşılaması için uyguladığımız titiz kontrol süreçleri.',
  'blog.home103.date': '5 Mart 2024',
  'blog.home103.readTime': '6 dk',

  // Collections Hero Slider
  'collectionsHero.slide1.tag': 'Toptan Halı Satışı',
  'collectionsHero.slide1.title': 'Premium Halı\nKoleksiyonları',
  'collectionsHero.slide1.subtitle': 'Gaziantep\'ten dünyaya uzanan toptan halı üretimi ile 50+ ülkeye ihracat',
  'collectionsHero.slide1.stat1Label': 'İhracat Ülkesi',
  'collectionsHero.slide1.stat2Label': 'Yıllık Tecrübe',
  'collectionsHero.slide2.tag': 'Toptan Halı Üretimi',
  'collectionsHero.slide2.title': 'Halı Toptan\nSatış Merkezi',
  'collectionsHero.slide2.subtitle': 'ISO 9001 sertifikalı üretim tesislerimizde günlük binlerce m² halı üretimi',
  'collectionsHero.slide2.stat1Label': 'Özel Koleksiyon',
  'collectionsHero.slide2.stat2Label': 'Aktif Bayi',
  'collectionsHero.slide3.tag': 'Halı İhracatı',
  'collectionsHero.slide3.title': 'Dünyaya Açılan\nHalı Fabrikası',
  'collectionsHero.slide3.subtitle': 'Modern tasarımlar ve geleneksel el işçiliğiyle yaşam alanlarınıza değer katın',
  'collectionsHero.slide3.stat1Label': 'm² Yıllık Üretim',
  'collectionsHero.slide3.stat2Label': 'Benzersiz Desen',
  'collectionsHero.cta.explore': 'Koleksiyonları Keşfet',
  'collectionsHero.cta.price': 'Toptan Fiyat Al',
  'collectionsHero.aria.slider': 'Toptan Halı Koleksiyonları Hero Slider',
  'collectionsHero.aria.slide': 'Slayt',
  'collectionsHero.aria.prev': 'Önceki slayt',
  'collectionsHero.aria.next': 'Sonraki slayt',
  'collectionsHero.aria.goto': 'Koleksiyonlara git',
};

export default common;